import {LAYER_SUBTYPE} from "@frontend/components/modules/layouts-page/modals/layout-preview/constants";
import MediaAPI from "@frontend/services/api/media";
import {settingFlag, settingNumber} from "./template-settings";

/**
 * @type FieldMapper
 */
export const productImageMapper = async ({
  templateSettings,
  index,
  layoutId
}) => {
  const properties = {
    subType: LAYER_SUBTYPE.IMAGE,
    scale: settingNumber(templateSettings, 'scale', index, 1),
    flipX: settingFlag(templateSettings, 'p_flipX', index),
    flipY: settingFlag(templateSettings, 'p_flipY', index),
    width: settingNumber(templateSettings, 'p_width', index),
    height: settingNumber(templateSettings, 'p_height', index),
    angle: settingNumber(templateSettings, 'angle', index)
  };

  if (templateSettings.file_ids) {
    const fileIds = templateSettings.file_ids.split(',');
    const fileId = fileIds[index];
    const { data: fileIdsData } = await MediaAPI.getBannerView({
      file_ids: fileId,
      show_warning: true,
      layout_id: layoutId
    });
    
    if (!fileIdsData.files) {
      return properties;
    }
    
    const fileData = fileIdsData.files[0];
    properties.src = fileData ? `/share?file=${fileData.path}` : null;
  }

  return properties;
}
